function addToCart() {
  const wrapper = document.querySelectorAll(".lr-card-wrapper");

  for (let i = 0; i < wrapper.length; i++) {
    const card = wrapper[i];

    card.addEventListener("mouseenter", () => {
      const buyBtn = card.children[1].children[0].children[2];
      buyBtn.style.bottom = 0;
    });

    card.addEventListener("mouseleave", () => {
      const buyBtn = card.children[1].children[0].children[2];
      buyBtn.style.bottom = "-100px";
    });
  }
}

addToCart();

function sliderIndicator() {
  const indicator = document.querySelector(".lr-test-dots");
  const counter = document.querySelectorAll(".slider-counter--total");

  for (let i = 0; i < counter.length; i++) {
    const total = counter[i];
  }

  const total = parseInt(counter);

  let i = 0;
  while (i < total) {
    // creates a dot for each slide
    const dot = document.createElement("span");
    dot.classList.add("indicator-dot");
    // indicator.appendChild(dot);
    i++;
  }
}

sliderIndicator();
